import Spinner from './spinner'
import s from './loader/loader.module.scss'

// Renders the same full-screen visual as `<Loader>` so the Suspense
// fallback and the in-page loader look continuous instead of flashing
// between two different spinners.
export default function SplashScreen() {
  return (
    <div className={s.wrapper}>
      <Spinner className={s.loader} color="white" size="lg" />
    </div>
  )
}
